import React from "react";

/** Left-rail client snapshot for the delivery workspace: intake fields +
 *  GoHighLevel contact summary. */
export default function DeliverySnapshot({ workspace, intakeFields }) {
  const ghl = workspace.ghl_contact_snapshot;
  return (
    <aside
      data-testid="delivery-snapshot"
      className="rounded-3xl border border-sand-300 bg-sand-50 p-5 sm:p-6 self-start lg:sticky lg:top-24"
    >
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-clay">
        Client snapshot
      </p>
      <h2 className="mt-2 font-display text-lg font-semibold text-ink leading-tight">
        {workspace.client_name || "—"}
      </h2>
      <a
        href={`mailto:${workspace.client_email}`}
        className="mt-1 block text-[13px] text-ink-muted hover:text-clay transition-colors break-all"
      >
        {workspace.client_email}
      </a>

      <dl className="mt-5 space-y-3">
        {intakeFields.map((f) => (
          <div key={f.key}>
            <dt className="font-mono text-[9.5px] uppercase tracking-[0.16em] text-ink-muted">
              {f.label}
            </dt>
            <dd className="mt-1 text-[13px] text-ink leading-snug whitespace-pre-wrap">
              {f.value}
            </dd>
          </div>
        ))}
      </dl>

      {ghl && (
        <div className="mt-6 pt-5 border-t border-sand-300/70">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-clay">
            GoHighLevel
          </p>
          <p className="mt-2 text-[12px] text-ink-muted">
            Contact ID:{" "}
            <span className="font-mono text-ink">
              {ghl.id?.slice(0, 14) || "—"}…
            </span>
          </p>
          {ghl.tags?.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-1.5">
              {ghl.tags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center rounded-full border border-clay/30 bg-clay/10 px-2 py-0.5 font-mono text-[10px] text-clay"
                >
                  {t}
                </span>
              ))}
            </div>
          )}
        </div>
      )}
    </aside>
  );
}
